import { createSlice } from '@reduxjs/toolkit';

import { arrayUnflatten } from 'features/shops/features/categories/utils/arrayUnflatten';

import { productsCategoriesApi } from '../service/categories';
import { RootState } from '../../../../../store';
import { CategoryState } from '../service/categories.interface';

const initialState: CategoryState = {
    nestedCategoryList: [],
};

const allCatrgoriesItem = {
    id: null,
    name: 'Все категории',
    parent_id: 0,
};

export const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addMatcher(
            productsCategoriesApi.endpoints.readCategories.matchFulfilled,
            (state, { payload }) => {
                const flatCategoryList = structuredClone(payload.items);

                const nestedCategoryList = arrayUnflatten(flatCategoryList);
                nestedCategoryList.unshift(allCatrgoriesItem);

                state.nestedCategoryList = nestedCategoryList;
            }
        );
    },
});

export const getCategoryState = (state: RootState): CategoryState =>
    state.category;

export const categoryReducer = categorySlice.reducer;
